import React from 'react';
import { ButtonV2 } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';

interface FilterButtonProps {
  text: string;
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
  isDisabled?: boolean;
}

export const DropdownButton: React.FC<FilterButtonProps> = ({ text, startIcon, endIcon, isDisabled }) => {
  return (
    <ButtonV2
      variant="outline"
      height="fit-content"
      paddingX={4}
      paddingY={3}
      typographyVariant="label2"
      fontSize={{ _: pxToRem(11), md: pxToRem(13) }}
      intent="neutral"
      border="1px solid"
      borderRadius={3}
      borderColor="mono3"
      startIcon={startIcon}
      endIcon={endIcon}
      disabled={isDisabled}
      _hover={{
        backgroundColor: 'rgba(73, 81, 239, 0.10)',
        borderColor: 'newUITest1',
        color: 'newUITest1',
      }}
    >
      {text}
    </ButtonV2>
  );
};
